module.exports = {"id":"226766","name":"Daniel Podence","rating":"76","photo":"./data/images/photos/0/226766.png","club":{"name":"Sporting CP","logo":"./data/images/clubs/SportingCP.png"},"positions":["ATT","MD","BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanielPodence0.json
// module id = 937
// module chunks = 0